class BESSAppProjectCreditScopeOut extends BESSAppBase {

    constructor(credit) {
        super();
        this.credit = credit;
        this.node = this.credit.node.find('.app-credit-scope-in-out');
        if (this.node.length === 0) {
            return;
        }
        this.scopeOutReason = this.credit.node.find('.app-scope-out-reason');
        this.scopeOutNoReason = this.credit.node.find('.app-scope-out-no-reason');
        this.scopeOutEditReason = this.credit.node.find('.app-edit-scope-out-reason');
        this.onSelected(this.scopeOutEditReason, this.editReason);
        this.onSelected(this.node, this.updateState);
        this.isScopeOut = this.node.hasClass('bi-primary');
        this.node.attr('aria-checked', this.isScopeOut);
        this.showHideSubCredits();
        this.credit.node.addClassIf('app-credit-scoped-out', this.isScopeOut);
    }

    getScopeOutReason() {
        return this.scopeOutReason.text().trim();
    }

    setScopeOutReason(reason) {
        this.scopeOutReason.html(reason.trim());
        this.scopeOutNoReason.showIf(reason.trim().length === 0);
    }


    setIsScopeOut(value) {
        this.isScopeOut = value;

        this.node.addClassIf('bi-primary', this.isScopeOut);
        this.node.addClassIf('bi-secondary', !this.isScopeOut);
        this.node.attr('aria-checked', this.isScopeOut);
    }

    updateState() {

        if (!this.isScopeOut) {
            this.editReason();
        } else {
            this.setIsScopeOut(false);
            this.save();
        }
    }

    showHideSubCredits() {
        $('.app-sub-credit-' + this.credit.codeSelector).showAnimatedIf(!this.isScopeOut);
    }

    editReason() {
        this.askForDescriptiveTextInput(
            "Scope out",
            "<p>Scope out reason for " + this.credit.title + ":</p>",
            this.getScopeOutReason(),
            function (reason) {
                this.setScopeOutReason(reason);
                this.setIsScopeOut(reason && reason.trim().length > 0);
                this.save();
            }
        );
    }

    save() {
        this.credit.node.addClassIf('app-credit-scoped-out', this.isScopeOut);
        this.showHideSubCredits();

        let scopeOutReason = this.getScopeOutReason();
        this.credit.api.apiUpdateScopeOut(this.isScopeOut, scopeOutReason, function () {

            this.fireEvent(new BESSAppProjectCreditUpdatedEvent());

        }.bind(this));
    }
}